(() => {
  if (window.wbCollectionAlignment) return;
  window.wbCollectionAlignment = true;
  let timer, firstPending = 0, lastWidth = window.innerWidth;
  // Coalesce asynchronous swatch updates instead of measuring on every frame.
  const schedule = () => {
    const now = performance.now();
    if (!firstPending) firstPending = now;
    clearTimeout(timer);
    timer = setTimeout(() => {
      firstPending = 0;
      requestAnimationFrame(align);
    }, Math.max(0, Math.min(120, 500 - (now - firstPending))));
  };
  function align() {
    const grid = document.getElementById('product-grid');
    if (!grid || !grid.getBoundingClientRect().width) return;
    const entries = Array.from(grid.children).map(item => {
      const card = item.querySelector('.card-wrapper > .card');
      const heading = card?.querySelector(':scope > .card__content .card__heading');
      return {item, card, heading, price: card?.querySelector(':scope > .card__content .price__container'), button: card?.querySelector(':scope > .card__content .quick-add__submit')};
    }).filter(e => e.card && e.heading);
    // Reset every card before reading any geometry.
    entries.forEach(({card, heading, button, price}) => {
      card.style.removeProperty('--wb-card-height');
      heading.style.removeProperty('--wb-title-offset');
      heading.style.removeProperty('--wb-title-height');
      button?.style.removeProperty('--wb-button-height');
      price?.style.removeProperty('--wb-price-height');
    });
    const rows = [];
    entries.forEach(e => {
      const headingRect = e.heading.getBoundingClientRect();
      e.titleTop = headingRect.top - e.card.getBoundingClientRect().top;
      e.titleHeight = headingRect.height;
      e.buttonHeight = e.button?.getBoundingClientRect().height || 0;
      const top = e.item.offsetTop;
      let row = rows.find(r => Math.abs(r.top - top) < 3);
      if (!row) rows.push(row = {top, entries: []});
      row.entries.push(e);
    });
    // All rows have been measured: write title alignment together.
    rows.forEach(({entries: row}) => {
      const titleTop = Math.max(...row.map(e => e.titleTop));
      const titleHeight = Math.max(...row.map(e => e.titleHeight));
      const buttonHeight = Math.max(40, ...row.map(e => e.buttonHeight));
      row.forEach(e => {
        e.heading.style.setProperty('--wb-title-offset', `${Math.max(0, titleTop - e.titleTop)}px`);
        e.heading.style.setProperty('--wb-title-height', `${titleHeight}px`);
        e.button?.style.setProperty('--wb-button-height', `${buttonHeight}px`);
      });
    });
    // Align the price areas after title alignment, including mixed sale/regular rows.
    const priceHeights = rows.map(({entries: row}) => Math.max(0, ...row.map(e => e.price?.getBoundingClientRect().height || 0)));
    rows.forEach(({entries: row}, index) => {
      row.forEach(e => e.price?.style.setProperty('--wb-price-height', `${priceHeights[index]}px`));
    });
    // One further read phase, then one write phase for card heights.
    const heights = rows.map(({entries: row}) => Math.max(...row.map(e => e.card.getBoundingClientRect().height)));
    rows.forEach(({entries: row}, index) => {
      row.forEach(e => e.card.style.setProperty('--wb-card-height', `${heights[index]}px`));
    });
  }
  const containsGrid = node => node.nodeType === 1 &&
    (node.id === 'product-grid' || node.querySelector('#product-grid'));
  new MutationObserver(records => {
    const grid = document.getElementById('product-grid');
    if (records.some(record =>
      (grid && (record.target === grid || grid.contains(record.target))) ||
      Array.from(record.addedNodes).some(containsGrid)
    )) schedule();
  }).observe(document.body, {childList: true, subtree: true, characterData: true});
  window.addEventListener('resize', () => {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    schedule();
  });
  document.addEventListener('load', event => {
    if (event.target instanceof Element && event.target.closest('#product-grid')) schedule();
  }, true);
  document.addEventListener('shopify:section:load', schedule);
  document.fonts?.ready.then(schedule);
  schedule();
})();
